import React from 'react'
import TierIcon from './TierIcon'
import { STAGES, STAGE_LABELS, TIERS, TIER_META, formatNumber } from './embroideryFormat'

// Ma trận 4 công đoạn × (Tổng item + 4 mức hạn), theo mockup: bấm ô lọc cả hai chiều (cột Tổng = mọi công đoạn),
// bấm tên cột chỉ đổi công đoạn (bấm lại để bỏ chọn), bấm tên dòng chỉ đổi mức hạn — chiều còn lại giữ nguyên (FR-001)
const EmbroideryOverviewMatrix = ({ overview, filters, onSelect }) => {
    const rows = overview.rows
    const isSelected = (stage, deadline) => !!(stage || deadline) && filters.stage === stage && filters.deadline === deadline

    return (
        <table className='table EmbroideryMatrix'>
            <thead>
                <tr>
                    <th className='corner' />
                    {STAGES.map((stage) => (
                        <th
                            key={stage}
                            className={`clickable ${stage === 'unbatched' ? 'unb' : ''} ${filters.stage === stage ? 'selected' : ''}`}
                            onClick={() => onSelect({ stage: filters.stage === stage ? '' : stage })}
                        >
                            {STAGE_LABELS[stage]}
                        </th>
                    ))}
                    <th className='tot'>Tổng</th>
                </tr>
            </thead>
            <tbody>
                <tr className='totalRow'>
                    <th className='clickable' onClick={() => onSelect({ deadline: '' })}>
                        <TierIcon type='total' />
                        Tổng item
                    </th>
                    {STAGES.map((stage) => (
                        <td
                            key={stage}
                            className={`clickable ${isSelected(stage, '') ? 'selected' : ''}`}
                            onClick={() => onSelect({ stage, deadline: '' })}
                        >
                            {formatNumber(rows.total[stage])}
                        </td>
                    ))}
                    <td
                        className={`sum clickable ${isSelected('', '') ? 'selected' : ''}`}
                        onClick={() => onSelect({ stage: '', deadline: '' })}
                    >
                        {formatNumber(rows.total.total)}
                    </td>
                </tr>
                {TIERS.map((tier) => {
                    const meta = TIER_META[tier]
                    return (
                        <tr key={tier} className={`tier-${tier}`}>
                            <th
                                className={`clickable ${filters.deadline === tier ? 'selected' : ''}`}
                                onClick={() => onSelect({ deadline: tier })}
                            >
                                <TierIcon type={tier} />
                                {meta.label}
                                {meta.hint && <small className='ml-1 text-muted'>({meta.hint})</small>}
                            </th>
                            {STAGES.map((stage) => (
                                <td
                                    key={stage}
                                    className={`clickable ${isSelected(stage, tier) ? 'selected' : ''}`}
                                    onClick={() => onSelect({ stage, deadline: tier })}
                                >
                                    {formatNumber(rows[tier][stage])}
                                </td>
                            ))}
                            <td
                                className={`sum clickable ${isSelected('', tier) ? 'selected' : ''}`}
                                onClick={() => onSelect({ stage: '', deadline: tier })}
                            >
                                {formatNumber(rows[tier].total)}
                            </td>
                        </tr>
                    )
                })}
            </tbody>
        </table>
    )
}

export default EmbroideryOverviewMatrix
